"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _dropdown_toggle_props = require("./dropdown_toggle_props");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DropdownToggle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DropdownToggle, _PureComponent);

  function DropdownToggle() {
    _classCallCheck(this, DropdownToggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropdownToggle).apply(this, arguments));
  }

  _createClass(DropdownToggle, [{
    key: "render",
    // class标记
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          _onClick = _this$props.onClick,
          _onMouseOver = _this$props.onMouseOver,
          _onMouseOut = _this$props.onMouseOut,
          htmlRef = _this$props.htmlRef;
      var childrenProps = children && children.props || {};
      var globalPropsData = (0, _spauiUtils.globalProps)(this.props, childrenProps, DropdownToggle);
      var result = children,
          elementProps = {};

      if (!result) {
        // 没有内容就直接返回
        return null;
      } else if (typeof result === 'string') {
        // 如果直接是传的字符串，为了能够有点击内容，用span包裹一下
        result = _react["default"].createElement("span", null, result);
      } // 去掉默认带的ref


      if (_typeof(globalPropsData) === 'object' && globalPropsData && globalPropsData.ref) {
        delete globalPropsData.ref;
      }

      if (result && !(0, _spauiUtils.isFunction)(result.type)) {
        elementProps.ref = htmlRef;
      } else {
        elementProps.htmlRef = htmlRef;
      }

      return (0, _react.cloneElement)(result, _objectSpread({}, globalPropsData, elementProps, {
        onClick: function onClick(event) {
          // 支持原children的点击事件
          if ((0, _spauiUtils.isFunction)(_onClick)) {
            _onClick(event);
          }

          if (childrenProps && (0, _spauiUtils.isFunction)(childrenProps.onClick)) {
            childrenProps.onClick(event);
          }
        },
        onMouseOut: function onMouseOut(event) {
          if ((0, _spauiUtils.isFunction)(_onMouseOut)) {
            _onMouseOut(event);
          }

          if (childrenProps && (0, _spauiUtils.isFunction)(childrenProps.onMouseOut)) {
            childrenProps.onMouseOut(event);
          }
        },
        onMouseOver: function onMouseOver(event) {
          if ((0, _spauiUtils.isFunction)(_onMouseOver)) {
            _onMouseOver(event);
          }

          if (childrenProps && (0, _spauiUtils.isFunction)(childrenProps.onMouseOver)) {
            childrenProps.onMouseOver(event);
          }
        }
      }));
    }
  }]);

  return DropdownToggle;
}(_react.PureComponent);

_defineProperty(DropdownToggle, "propTypes", _dropdown_toggle_props.propTypes);

_defineProperty(DropdownToggle, "defaultProps", _dropdown_toggle_props.defaultProps);

_defineProperty(DropdownToggle, "name", 'DropdownToggle');

var _default = DropdownToggle;
exports["default"] = _default;